setTimeout(function () {
  var CartDrawerTimer1 = $("#CartDrawerTimer1");
  var CartDrawerTimer2 = $("#CartDrawerTimer2");

  function _timerPad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // Set the start time for timer 1
  var CartDrawerstartTime1 = 60 * 30; // 30 minutes

  // Set the start time for timer 2
  var CartDrawerstartTime2 = 60 * 15; // 15 minutes

  // Check if timer 1 is stored in local storage
  localStorage.removeItem("CartDrawerstartTime1");
  localStorage.removeItem("CartDrawerstartTime2");
  if (localStorage.getItem("CartDrawerstartTime1")) {
    CartDrawerstartTime1 = parseInt(localStorage.getItem("CartDrawerstartTime1"));
  }

  // Check if timer 2 is stored in local storage
  if (localStorage.getItem("CartDrawerstartTime2")) {
    CartDrawerstartTime2 = parseInt(localStorage.getItem("CartDrawerstartTime2"));
  }

  const _drawerBtn = document.querySelector(".drawer-btn");

  _intervalId1 = setInterval(function () {
    // Decrement the start time
    CartDrawerstartTime1--;

    // Store the start time in local storage
    localStorage.setItem("CartDrawerstartTime1", CartDrawerstartTime1);

    // Calculate the minutes and seconds
    var minutes = Math.floor(CartDrawerstartTime1 / 60);
    var seconds = CartDrawerstartTime1 % 60;

    // Update the timer text

    CartDrawerTimer1.text(minutes + ":" + _timerPad(seconds));

    // If the timer is complete, display a message
    if (CartDrawerstartTime1 < 0) {
      clearInterval(_intervalId1);
      CartDrawerTimer1.text("00:00");
    }
  }, 1000);

  // Update timer 2 every second
  _intervalId2 = setInterval(function () {
    // Decrement the start time
    CartDrawerstartTime2--;

    // Store the start time in local storage
    localStorage.setItem("CartDrawerstartTime2", CartDrawerstartTime2);

    // Calculate the minutes and seconds
    var minutes = Math.floor(CartDrawerstartTime2 / 60);
    var seconds = CartDrawerstartTime2 % 60;

    // Update the timer text
    CartDrawerTimer2.text(minutes + ":" + _timerPad(seconds));

    // If the timer is complete, display a message
    if (CartDrawerstartTime2 < 0) {
      clearInterval(_intervalId2);
      CartDrawerTimer2.text("00:00");
    }
  }, 1000);

  if (_drawerBtn !== null) {
    _drawerBtn.addEventListener("click", function () {
      // Update timer 1 every second
      intervalId1;
      intervalId2;
    });
  }

  $('.timer.timer_new_30').insertAfter('.popup-drawer-header');
  $('.timer.timer_new_15').insertAfter('.popup-drawer-header');
}, 3000);